import { createContext } from 'react';
const ClueDetailContext = createContext<any>({});
export default ClueDetailContext;